// extracted by mini-css-extract-plugin
export default {"button":"BlueButton_button__-5Lp0"};